import { CustomAction } from '@nimmsta/ng-commons-lib/data-table';
import { DataConnectionType, Job } from '@nimmsta/ng-commons-lib/models';
import { Observable, of } from 'rxjs';

export class CsvJobAction extends CustomAction<Job> {
  constructor(
    _text: string,
    isDelete = false,
  ) {
    super(_text, false, isDelete);
  }

  override isEnabled(item: Job): Observable<boolean> {
    return of(item?.dataConnection?.dataConnectionHandler === DataConnectionType.CSVDataConnection);
  }
}
